import { FeiertagskontoContentDesktop } from '@/domain/mitarbeiter/features/feiertagskonto';
import { FeiertagskontoActive } from '@/domain/mitarbeiter/pages/feiertagskonto/overview/FeiertagskontoActive';
import { FeiertagskontoDeactive } from '@/domain/mitarbeiter/pages/feiertagskonto/overview/FeiertagskontoDeactive';
export function DesktopPage({
  isActive,
  handleChange,
}: {
  isActive: boolean;
  handleChange: () => Promise<void>;
}) {
  return (
    <div className="flex flex-col gap-8">
      {isActive ? (
        <div className="flex flex-col gap-8">
          <FeiertagskontoContentDesktop />
          <FeiertagskontoActive handleChange={handleChange} />
        </div>
      ) : (
        <FeiertagskontoDeactive handleChange={handleChange} />
      )}
    </div>
  );
}
